import * as Actions from "../../actions/cases/viewCaseDetailsActions";

const initialState = {
  loading: false,
  caseId: "",
  caseNo: "",
  subject: "",
  createdDate: "",
  contact: "",
  assignedTo: {},
  caseType: "",
  initialEnquiry: "",
  closedDate: "",
  status: "",
  attachments: [],
  openCommentsModal: false,
  comments: "",
  commentErr: false,
  disableSubmit: true,
  openCancelModal: false,
  commentAttachmentCheck: false,
  commentAttachmentError: false,
  commentAttachmentErrorMsg: "",
  commentsLoading: false,
  threadId: "",
  commentAttachments: [],
  caseReplySuccess: false,
  environment: "",
  toEmailAddress: "",
  handleCommentAttachmentSubmit: false,
  cancelCommentDisable: true,
  attachmentStatusResponse: [],
  attachmentName: [],
  attachmentToUpload: [],
  activityList: [],
  activityError: false,
  openedBy: "",
  closeCaseSuccess: false,
  closeCaseError: false,
  requestClosure: false,
};

const arr = [];

const viewCaseDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SET_LOADER:
      return {
        ...state,
        loading: action.value,
      };

    case Actions.GET_ALL_VIEW_CASE_DETAILS:
      return {
        ...state,
        // loading: true,
      };

    case Actions.SET_ALL_VIEW_CASE_DETAILS:
      return {
        ...state,
        caseNo: action.response.caseNo,
        subject: action.response.subject,
        createdDate: action.response.created_date,
        contact: action.response.contact?.contactName,
        openedBy: action.response.customer_contact_name,
        initialEnquiry: action.response.initialEnquiry,
        assignedTo: action.response.assignedTo,
        caseType: action.response.caseType,
        status: action.response.status,
        attachments: action.response.attachments === null || action.response.attachments === undefined ? arr : action.response.attachments,
        threadId: action.response.threadId,
        toEmailAddress: action.response.autoResponseEmail,
        closedDate: action.response.closedDate,
        requestClosure: action.response.requestClosure,
      };

    case Actions.GET_ACTIVITY:
      return { ...state };

    case Actions.SET_ACTIVITY:
      return { ...state, activityList: action.response };

    case Actions.SET_ACTIVITY_ERROR:
      return { ...state, activityError: action.err };

    case Actions.CLOSE_CASE:
      return { ...state };

    case Actions.CLOSE_CASE_SUCCESS:
      return { ...state, closeCaseSuccess: action.response };

    case Actions.CLOSE_CASE_ERROR:
      return { ...state, closeCaseError: action.err };

    case Actions.RESET_CLOSE_CASE:
      return { ...state, closeCaseSuccess: false, closeCaseError: false };

    case Actions.SET_CASE_ID:
      return {
        ...state,
        caseId: action.value,
      };
    case Actions.SET_COMMENTS_LOADER:
      return {
        ...state,
        commentsLoading: action.value,
      };
    case Actions.SET_COMMENTS_MODAL:
      return {
        ...state,
        openCommentsModal: action.value,
      };
    case Actions.SET_ATTACHMENTS_COMMENT:
      return {
        ...state,
        commentAttachments: action.value,
      };
    case Actions.SET_COMMENTS:
      return {
        ...state,
        comments: action.value,
      };
    case Actions.SET_COMMENT_ERR:
      return {
        ...state,
        commentErr: action.value,
      };
    case Actions.SET_CASE_REPLY:
      return {
        ...state,
        caseReplySuccess: action.value,
      };
    case Actions.SUBMIT_COMMENT_ATTACHMENT:
      return {
        ...state,
        handleCommentAttachmentSubmit: action.value,
      };
    case Actions.SET_ENVIRONMNET:
      return {
        ...state,
        environment: action.value,
      };
    case Actions.SET_COMMENTS_SUBMIT:
      return {
        ...state,
        disableSubmit: action.value,
      };
    case Actions.SET_CANCEL_MODAL:
      return {
        ...state,
        openCancelModal: action.value,
      };
    case Actions.ADD_COMMENT_ATTACHMENT_ERROR:
      return {
        ...state,
        commentAttachmentError: action.value,
        commentAttachmentErrorMsg: action.msg,
      };

    case Actions.COMMENT_ATTACHMENT_CHECK:
      return {
        ...state,
        commentAttachmentCheck: action.value,
      };

    case Actions.RESET_COMMENT_ATTACHMENT:
      return {
        ...state,
        commentAttachmentError: false,
        commentAttachmentErrorMsg: "",
      };

    case Actions.RESET_ADD_COMMENTS:
      return {
        ...state,
        openCommentsModal: false,
        comments: "",
        commentErr: false,
        disableSubmit: true,
        openCancelModal: false,
        cancelCommentDisable: true,
        files: [],
        commentAttachments: [],
        commentAttachmentError: false,
        commentAttachmentErrorMsg: "",
      };
    case Actions.DISABLE_COMMENT_CANCEL:
      return {
        ...state,
        cancelCommentDisable: action.value,
      };

    case Actions.ATTACHMENT_STATUS_RESPONSE:
      return {
        ...state,
        attachmentStatusResponse: action.value,
      };
    case Actions.SET_ATTACHMENT_NAME:
      return {
        ...state,
        attachmentName: action.value,
      };
    case Actions.SET_ATTACHMENT:
      return {
        ...state,
        attachmentToUpload: action.value,
      };

    case Actions.RESET_VIEW_CASE_DETAILS:
      return initialState;

    default:
      return state;
  }
};

export default viewCaseDetailsReducer;
